import {
  ADD_BOOKING_TEMPLATE_NAME,
  GET_ALL_BOOKING_TEMPLATE_BY_COMPANY_ID,
  GET_ALL_BOOKING_NAME,
} from "../constants";
import { ApiCall } from "../../utils/index"

export const addBookingTemplateName =
  (name, cb) => async (dispatch, getState) => {
    try {
      const {
        auth: { token },
      } = getState();
      const result = await ApiCall.get(`/bookingTemplate/existing/${name}`, token);
      dispatch({
        type: ADD_BOOKING_TEMPLATE_NAME,
        payload: name,
      });
      cb(result);
    } catch (err) {
      cb(err);
    }
  };

// Create booking template
export const createBookingTemplate =
  (request) => async (dispatch, getState) => {
    try {
      const {
        auth: { token },
      } = getState();
      const result = await ApiCall.post("/bookingTemplate", request.payload, token);
      request.onSuccess(result.data);
    } catch (error) {
      request.onError(error);
    }
  };

// Get Template Custome field by booking template id
export const getTemplateCustomeField =
  (request) => async (dispatch, getState) => {
    try {
      const {
        auth: { token },
      } = getState();
      const result = await ApiCall.get(`/bookingTemplate/byId/${request.booking_template_id}`, token);
      request.onSuccess(result.data);
    } catch (error) {
      console.log({error})
      request.onError(error);
    }
  };

// Update Template Custome field
export const updateBookingTemplate =
  (request) => async (dispatch, getState) => {
    try {
      const {
        auth: { token },
      } = getState();
      const result = await ApiCall.patch(`/bookingTemplate/`, request.payload, token)
      request.onSuccess()
    } catch (error) {
      console.log({ error });
      request.onError(error);
    }
  };

export const getAllBookingByCompanyId = (cb, debouncedHandleSearch, page, row_count, sortField, sortOrder) => async (dispatch, getState) => {
  try {
    const {
      auth: { token },
    } = getState();

    let url = "/bookingTemplate/company"

    if(page) {
      const searchParam = debouncedHandleSearch ? `search=${debouncedHandleSearch}&` : "";
      const params = `?${searchParam}page=${page}&page_size=${row_count}&sort_by=${sortField}&sort_order=${sortOrder}`;
      url = url + params
    }
    
    const result = await ApiCall.get(url, token);
    dispatch({
      type: GET_ALL_BOOKING_TEMPLATE_BY_COMPANY_ID,
      payload: result.data,
    });
    cb(result);
  } catch (err) {
    cb(err);
  }
};

export const getAllBookingName =
(bookingpropsid, cb) => async (dispatch, getState) => {
    try {
      const {
        auth: { token },
      } = getState();
      const result = await ApiCall.get(`/bookingTemplate/byId/${bookingpropsid}`, token);
      dispatch({
        type: GET_ALL_BOOKING_NAME,
        payload: result.data,
      });
      cb(result);
    } catch (err) {
      cb(err);
    }
  };

export const deleteBookingTemplate =
  (booking_template_id, cb) => async (dispatch, getState) => {
    try {
      const {
        auth: { token },
      } = getState();
      const result = await ApiCall.delete(`/bookingTemplate/${booking_template_id}`, token);
      cb(result);
    } catch (err) {
      cb(err);
    }
  };

export const getAllCustomFieldsByBookingTemplateId =
  (bookingtemplateid, cb) => async (dispatch, getState) => {
    try {
      const {
        auth: { token },
      } = getState();
      const result = await ApiCall.get(`/bookingTemplate/customfields/${bookingtemplateid}`, token);

      cb(result);
    } catch (err) {
      cb(err);
    }
  };
